<template>
  <div id="app">
    <div
      v-if="
        is_loaded &&
        $route.path.indexOf('/publicity') !== 0 &&
        $route.path.indexOf('/about') !== 0
      "
    >
      <app-header />
      <div class="dateBox common">
        <app-left-sidebar />
        <div class="dateRight">
          <router-view />
        </div>
      </div>
      <app-footer />
    </div>

    <div v-if="$route.path.indexOf('/publicity') === 0">
      <router-view />
    </div>

    <div v-if="$route.path.indexOf('/about') >= 0">
      <app-header />
      <div class="dateBox common">
        <router-view />
      </div>
      <app-footer />
    </div>
  </div>
</template>

<script>
import AppHeader from "./components/app-header";
import AppFooter from "./components/app-footer";
import AppLeftSidebar from "./components/app-left-sidebar";

export default {
  name: "App",
  components: {
    AppHeader,
    AppFooter,
    AppLeftSidebar,
  },
  data() {
    return {
      is_loaded: false,
    };
  },
  created() {
    // 获取时间节点
    let _this = this;
    this.$http({
      url: "/home/timenode",
      method: "get",
      crossdomain: true,
    })
      .then(function (res) {
        _this.$store.commit("set_time_node", res.data);
        _this.is_loaded = true;
      })
      .catch(function (error) {
        console.log(error);
      });
  },
};
</script>

<style scoped>
@import "./assets/css/main.css";
</style>
